export interface EnvironmentData {
  viewportWidth: number;
  viewportHeight: number;
  timezone: string;
  language: string;
  userAgent: string;
}

export function getEnvironmentData(): EnvironmentData {
  let timezone = "unknown";
  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // Fallback for older browsers without Intl support
  }

  return {
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    timezone,
    language: navigator.language,
    userAgent: navigator.userAgent,
  };
}
